exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-6263ad62]{line-height:1.25;font-style:italic;color:#3d3d3d}.offer-content[data-v-6263ad62]{background-color:#fff23d}@media (max-width:639px){.detail[data-v-6263ad62]{max-width:12rem}}", ""]);

// exports
